type AppEnv = {
  apiGatewayUrl: string
  apiTimeoutMs: number
  sentryDsn?: string
  appEnv: string
  appVersion: string
  sessionStorageKey: string
  csrfEnabled: boolean
}

export function getAppEnv(): AppEnv {
  return {
    // Support both old VITE_API_GATEWAY_URL and new VITE_API_BASE_URL
    apiGatewayUrl:
      import.meta.env.VITE_API_BASE_URL ||
      import.meta.env.VITE_API_GATEWAY_URL ||
      '/api',
    apiTimeoutMs: Number(import.meta.env.VITE_API_TIMEOUT_MS || 15000),
    sentryDsn: import.meta.env.VITE_SENTRY_DSN,
    appEnv:
      import.meta.env.VITE_SENTRY_ENVIRONMENT ||
      import.meta.env.VITE_APP_ENV ||
      'development',
    appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
    sessionStorageKey:
      import.meta.env.VITE_SESSION_STORAGE_KEY || 'app-sgapex-web:session',
    csrfEnabled: import.meta.env.VITE_CSRF_ENABLED === 'true',
  }
}
